<h1 mat-dialog-title> {{header}}</h1>
<mat-dialog-content>
  <h3><i>{{body}}</i></h3>
</mat-dialog-content>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">NO</button>
  <button mat-button (click)="delete(this.apiUrl, this.id)">YES</button>
</div>
